import {APP_CONST} from "../../consts";

export const LOGIN = {
  MIN_YEAR: 1925,

  PAGE: {
    welcome: 0,
    registration: 1
  },

  DATE_OF_BIRTH_MONTH_LABELS: {
    default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    [APP_CONST.LANGUAGES_IDS.es]: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    [APP_CONST.LANGUAGES_IDS.pt_br]: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"]
  }
}
